import { Component, Input, NgModule, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateEventComponent } from '../create-event/create-event.component';



@Component({
  selector: 'app-get-my-events',
  templateUrl: './get-my-events.component.html',
  styleUrls: ['./get-my-events.component.css'],
})
export class GetMyEventsComponent implements OnInit {
  @Input() item = '';
  events: any[] = [];
  currentDate;
  expiredEvents: any[] = [];
  upcomingEvents: any[] = [];
  activeTab: 'all' | 'upcoming' | 'expired' = 'all';

  pageSize: number = 6;
  page: number = 1;
  eventDetails:any=[];
  updateForm;
  updatedData:any

  constructor(
    public activatedRoute: ActivatedRoute,
    public fb: FormBuilder,
    public router: Router,
    public authenticationService: AuthenticationService,
    private ngxService: NgxUiLoaderService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.getAllAnnouncements();
  }

  setTab(tab: 'all' | 'upcoming' | 'expired'): void {
    this.activeTab = tab;
    this.page = 1;
  }

  get activeEvents(): any[] {
    if (this.activeTab === 'upcoming') return this.upcomingEvents || [];
    if (this.activeTab === 'expired') return this.expiredEvents || [];
    return this.events || [];
  }

  get totalPages(): number {
    const total = this.activeEvents?.length || 0;
    return Math.max(1, Math.ceil(total / this.pageSize));
  }

  get pagedEvents(): any[] {
    const list = this.activeEvents || [];
    const start = (Math.max(1, this.page) - 1) * this.pageSize;
    return list.slice(start, start + this.pageSize);
  }

  prevPage(): void {
    if (this.page > 1) this.page -= 1;
  }

  nextPage(): void {
    if (this.page < this.totalPages) this.page += 1;
  }

  openModal(content: any, data: any) {
    // Convert UTC date string to IST Date object and format as needed
    const startTimeIST = new Date(new Date(data.startTime).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
    const endTimeIST = new Date(new Date(data.endTime).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

    // Store formatted strings in `eventDetails`
    this.eventDetails = {
      ...data,
      startTime: startTimeIST,
      endTime: endTimeIST
    };

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  openUpdate(eventId: any) {
    this.router.navigate(['/update-my-event'], { queryParams: { id: eventId} });
  }

  getAllAnnouncements() {
    this.ngxService.start();
    this.authenticationService
      .getAllMerchantEvents()
      .subscribe((res: any) => {
        this.events = Array.isArray(res?.data) ? res.data : [];
        this.expiredEvents = [];
        this.upcomingEvents = [];

        this.events.forEach((e: any) => {
          const dateTime = moment(e.validTill).format();
          let isUpcoming = moment(dateTime).isAfter(new Date());

          if (!isUpcoming) {
            this.expiredEvents.push(e)
          }
          else if (isUpcoming) {
            this.upcomingEvents.push(e);
          }
        });
        this.page = 1;
        this.ngxService.stop();
      }, error => {
        if (error) {
          Swal.fire(
            "error",
            error.error.message
          );
          this.ngxService.stop();
        }
      });
  }

  containsHttpOrHttps(url) {
    const pattern = /^(http:\/\/|https:\/\/)/i;
    return pattern.test(url);
  }
  checkImage(image:any) {
    if(image && this.containsHttpOrHttps(image)) {
      return image
    } else if(image && !this.containsHttpOrHttps(image)) {
       const [baseUrl, imgUrl] = image.split('uploads');
       return `https://services.ravel.faith/uploads/${imgUrl}`;
    } else {
      return 'https://climate.onep.go.th/wp-content/uploads/2020/01/default-image.jpg'
    }
   }
  changeSource(event: any) {
    return event.target.src = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJVBAe2Ohi5eo9kqXtmXu7iuqreWSQmy195p8ht0tONvjpX7sDBPHgrxQwXiyft-9cgAo&usqp=CAU";
  }

  onImgError(event: Event, fallbackSrc: string = 'assets/placeholderCoverPhoto.jpeg'): void {
    (event.target as HTMLImageElement).src = fallbackSrc;
  }

  createEvent() {
    this.router.navigate(['/create-my-event']);
  }
}
